import { render } from "./InspectionReportContent.vue?vue&type=template&id=1924fcf0&scoped=true"
import script from "./InspectionReportContent.vue?vue&type=script&lang=js"
export * from "./InspectionReportContent.vue?vue&type=script&lang=js"

import "./InspectionReportContent.vue?vue&type=style&index=0&id=1924fcf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1924fcf0"]])

export default __exports__